import { render } from "./LetterTemplates.vue?vue&type=template&id=b4558ad0&scoped=true"
import script from "./LetterTemplates.vue?vue&type=script&lang=js"
export * from "./LetterTemplates.vue?vue&type=script&lang=js"

import "./LetterTemplates.vue?vue&type=style&index=0&id=b4558ad0&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4558ad0"]])

export default __exports__